const getIndustry = (category, subCategory, list, t) => {
    if (!list || !category || !subCategory) return '-';
    const area =  list[category] || {};
    const sub = area?.sub || {};
    const areaDetail = sub[subCategory] || {};
    if (!area.name || !areaDetail.name) return '-';
    const tr = typeof t === 'function' ? t : v => v;
    return `${tr(area.name)} / ${tr(areaDetail.name)}`;
};
const getAddress = (data, list, extra, t) => {
    if (!list || !data || !list.length) return extra || '-';
    const province = list.find(item => item.value == data.province) || {};
    const city = province.children?.find(item => item.value == data.city) || {};
    if (!province.text || !city.text) return extra || '-';
    const tr = typeof t === 'function' ? t : v => v;
    return `${tr(province.text)} ${tr(city.text)} ${extra || ''}`;
};
export {
    getIndustry,
    getAddress,
};
